/* eslint-disable */
import React from 'react';
import { Doughnut, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const IndirectTaxPieChart = ({ Completed, Pending }) => {
  const data = {
    labels: ['Completed', 'Pending'],
    datasets: [
      {
        data: [Completed, Pending],
        backgroundColor: ['#2b5797', '#c9def4'],
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
          color: '#000',
          font: {
            family: 'sans-serif',
            size: 12,
          },
        },
      },
      datalabels: {
        color: 'black',          
        font: {
          size: 12,
          weight: 'bold',
        },
        formatter: (value) => value,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', maxWidth: '250px', height: '250px', margin: '0 auto', position: 'relative'}}>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default IndirectTaxPieChart;
